/**
 * Fisher-Yates (Knuth) shuffle — returns a new array with elements in random order.
 * Does NOT mutate the original array.
 */
export const shuffleArray = <T>(sourceList: readonly T[]): T[] => {
  const result: T[] = [...sourceList]
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    const temp = result[i] as T
    result[i] = result[j] as T
    result[j] = temp
  }
  return result
}
